export default {
  MANDATORY: 'mandatory',
  OPTIONAL: 'optional',
};
